export default __webpack_public_path__ + "static/media/catrina.404cc871.png";